import React, { useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, Spin, Table } from 'antd';
import ReactTooltip from 'react-tooltip';
//
import { Cards } from '../../../components/cards/frame/cards-frame';
import { getImportedCarIds, postImportCars } from '../../../redux/carImport/carAmigo/actionCreator';
import { UserTableStyleWrapper } from '../../pages/style';
import { TableWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { addImageFallback } from '../../../utility/utility';
import Heading from '../../../components/heading/heading';
import { BottomAction } from '../../car/Style';
import { getColorById, getBodyTypeById, importTargetPortals, ImportToType } from '../../../utils/caramigo';
import { contentAccordingToLang } from '../../../utils/common';
import { CheckIcon, DoubleCheckIcon } from '../../../components/utilities/icons';
import { CheckboxStyle } from '../../../components/checkbox/style';
import { getTopLevelDomain } from '../../../utils/constants';

const CarListingColumns = [
  {
    title: '',
    dataIndex: 'checkbox',
    key: 'checkbox',
  },
  {
    title: 'Image',
    dataIndex: 'image',
    key: 'image',
  },
  {
    title: 'Imported To',
    dataIndex: 'is_imported',
    key: 'is_imported',
  },
  {
    title: 'Brand',
    dataIndex: 'brand',
    key: 'brand',
  },
  {
    title: 'Model',
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: 'Year',
    dataIndex: 'year',
    key: 'year',
  },
  {
    title: 'KM Driven',
    dataIndex: 'km',
    key: 'km',
  },
  {
    title: 'Price',
    dataIndex: 'smaxPrice',
    key: 'smaxPrice',
  },
  {
    title: 'Initialized',
    dataIndex: 'initialized',
    key: 'initialized',
  },
  {
    title: 'Body Type',
    dataIndex: 'bodyType',
    key: 'bodyType',
  },
  {
    title: 'Color',
    dataIndex: 'color',
    key: 'color',
  },
  {
    title: 'Power',
    dataIndex: 'power',
    key: 'power',
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: 70,
    fixed: 'right',
  },
];

const CarListing = ({ queryState, setQueryState }) => {
  const dispatch = useDispatch();
  const [selectedCars, setSelectedCars] = useState([]);
  const [isImportLoading, setIsImportLoading] = useState(false);
  const [isAuto24ImportSelected, setIsAuto24ImportSelected] = useState(false);
  const [isAfricarImportSelected, setIsAfricarImportSelected] = useState(false);
  const { carAmigoCars, apiLoading, total, allImportedCarIds } = useSelector(reduxState => ({
    carAmigoCars: reduxState.carAmigo.carAmigoCars,
    apiLoading: reduxState.carAmigo.apiLoading,
    total: reduxState.carAmigo.total,
    allImportedCarIds: reduxState.carAmigo.allImportedCarIds,
  }));

  const topLevelDomain = getTopLevelDomain();
  const importablePortals = importTargetPortals(topLevelDomain);

  const handleCheck = id => {
    const carIndex = selectedCars.findIndex(el => el === id);
    const temp = [...selectedCars];
    if (carIndex === -1) temp.push(id);
    else temp.splice(carIndex, 1);
    setSelectedCars(temp);
  };

  const handleUploadCars = async () => {
    setIsImportLoading(true);
    const portal = [];
    if (isAfricarImportSelected) portal.push(importablePortals.africarPortal);
    if (isAuto24ImportSelected) portal.push(importablePortals.auto24Portal);
    const res = await dispatch(postImportCars(selectedCars, portal));
    if (res.status === 200) {
      setSelectedCars([]);
      setIsAfricarImportSelected(false);
      setIsAuto24ImportSelected(false);
      dispatch(getImportedCarIds());
    }
    setIsImportLoading(false);
  };

  const carListingTypes = [];

  carAmigoCars?.map(car => {
    const { id, picture, smaxPrice, brand, year, model, km, init, bodyType, color, power } = car;
    const mappedBodyType = getBodyTypeById(bodyType);
    const mappedColor = getColorById(color);
    let alreadyImported = false;
    let importedTo = '';
    const importedIndex = allImportedCarIds.findIndex(el => el.sourceId === `${id}`);
    let importedPortals = [];
    if (importedIndex !== -1) {
      alreadyImported = true;
      const currentCar = allImportedCarIds[importedIndex];
      if (currentCar?.importedPortals) {
        importedPortals = currentCar.importedPortals;
        if (
          importedPortals.some(p => p.portal === importablePortals.auto24Portal) &&
          importedPortals.some(p => p.portal === importablePortals.africarPortal)
        )
          importedTo = ImportToType.both;
        else if (importedPortals.some(p => p.portal === importablePortals.auto24Portal)) importedTo = importablePortals.africarPortal;
        else if (importedPortals.some(p => p.portal === importablePortals.africarPortal)) importedTo = importablePortals.auto24Portal;
      } else importedTo = importablePortals.auto24Portal;
    }
    const getCheckIconByImport = importType => {
      if (importType === ImportToType.both)
        return (
          <>
            <span data-tip={`Imported on ${importablePortals.auto24Portal} and ${importablePortals.africarPortal}`} data-for="already-imported-tooltip-both">
              <DoubleCheckIcon size={18} color="green" />
              <ReactTooltip id="already-imported-tooltip-both" place="top" effect="solid" />
            </span>
          </>
        );
      else if (importType === importablePortals.auto24Portal)
        return (
          <>
            <span data-tip={`Imported on ${importablePortals.auto24Portal}`} data-for="already-imported-tooltip-auto24">
              <CheckIcon size={18} color="blue" />
            </span>
            <ReactTooltip id="already-imported-tooltip-auto24" place="top" effect="solid" />
          </>
        );
      else if (importType === importablePortals.africarPortal)
        return (
          <>
            <span data-tip={`Imported on ${importablePortals.africarPortal}`} data-for="already-imported-tooltip-africar">
              <CheckIcon size={18} color="green" />
            </span>
            <ReactTooltip id="already-imported-tooltip-africar" place="top" effect="solid" />
          </>
        );
      else return <></>;
    };

    return carListingTypes.push({
      key: id,
      checkbox: (
        <div style={{ display: 'flex', flexDirection: 'row', gap: '4px' }}>
          {alreadyImported ? getCheckIconByImport(importedTo) : <></>}
          {importedTo !== ImportToType.both ? (
            <>
              <Checkbox name="car-amigo-action" checked={selectedCars.includes(id)} onChange={() => handleCheck(id)} />
            </>
          ) : (
            <></>
          )}
        </div>
      ),
      image: (
        <figure>
          <img
            src={picture}
            alt={`${brand}-${model}`}
            onError={addImageFallback}
            height={80}
            width={80}
            style={{ objectFit: 'cover', borderRadius: '5px' }}
          />
        </figure>
      ),
      is_imported: (
        <span>
          {/* {alreadyImported
            ? importedPortals.join(' , ')
            : '-'} */}
          {
            alreadyImported ? 
            (
              importedPortals?.length > 0 ?
              importedPortals.map(portal => <p className='m-0'>{portal.portal}: {portal.status}</p>)
              : '-'
            )
            : '-'
          }
        </span>
      ),
      brand: (
        <div className="user-info text-capitalize">
          <Heading className="user-name" as="h6">
            {brand}
          </Heading>
        </div>
      ),
      model: <span className="text-capitalize">{model}</span>,
      year: <span>{year}</span>,
      km: <span>{km} KM</span>,
      smaxPrice: <span>€ {new Intl.NumberFormat('fr-FR').format(smaxPrice)}</span>,
      initialized: <span>{init ? 'YES' : 'NO'}</span>,
      bodyType: mappedBodyType?.details ? contentAccordingToLang(mappedBodyType.details).name : '-',
      color: mappedColor || '-',
      power,
      actions: (
        <div className="table-actions">
          <>
            <Link to={`/admin/car-import/caramigo/${id}`}>
              <Button className="btn-icon" type="info" to="#" shape="circle">
                <FeatherIcon icon="eye" size={16} />
              </Button>
            </Link>
          </>
        </div>
      ),
    });
  });

  return (
    <Cards headless>
      {apiLoading || isImportLoading ? (
        <div className="spin">
          <Spin />
        </div>
      ) : (
        <UserTableStyleWrapper>
          <TableWrapper className="table-responsive">
            <Table
              dataSource={carListingTypes}
              columns={CarListingColumns}
              pagination={{
                current: queryState.page,
                defaultPageSize: queryState.limit,
                total,
                showSizeChanger: true,
              }}
              onChange={data => setQueryState(prev => ({ ...prev, page: data.current, limit: data.pageSize }))}
            />
          </TableWrapper>
        </UserTableStyleWrapper>
      )}
      {selectedCars.length > 0 && (
        <BottomAction>
          <div className="bottom-action-container">
            <div>Import {selectedCars.length} Cars to:</div>
            <div style={{ display: 'flex', gap: '8px' }}>
              <div>
                <CheckboxStyle
                  style={{ color: 'white' }}
                  checked={isAuto24ImportSelected}
                  onChange={e => setIsAuto24ImportSelected(e.target.checked)}
                >
                  {importablePortals.auto24Portal}
                </CheckboxStyle>
              </div>
              {
                importablePortals.africarPortal && (
                  <div>
                    <CheckboxStyle
                      style={{ color: 'white' }}
                      checked={isAfricarImportSelected}
                      onChange={e => setIsAfricarImportSelected(e.target.checked)}
                  >
                    {importablePortals.africarPortal}
                  </CheckboxStyle>
                </div>
                )
              }
            </div>
            <Button
              className="action-btn"
              style={
                isImportLoading || !(isAfricarImportSelected || isAuto24ImportSelected)
                  ? { backgroundColor: '#155BDC', color: '#fff', opacity: '0.7' }
                  : { backgroundColor: '#155BDC', color: '#fff' }
              }
              onClick={handleUploadCars}
              disabled={isImportLoading || !(isAfricarImportSelected || isAuto24ImportSelected)}
            >
              {isImportLoading ? 'Importing...' : 'Import'}
            </Button>
          </div>
        </BottomAction>
      )}
    </Cards>
  );
};

export default CarListing;
